import React, { useEffect, useState } from "react";
import FormRow from "./Row/FormRow";
import "./formTable.css";

function FormTable({ formData, selectedFileData, setSelectedFileData, unfilledFields, activeTab, textareaHeights, updateTextareaHeight }) {
  const [clearClicked, setClearClicked] = useState(false);

  const handlePropertyChange = (propertyType, newValue, property) => {
    setSelectedFileData((data) => {
      return data.map((item) => {
        return item.Property === property
          ? { ...item, [propertyType]: newValue }
          : item;
      });
    });
  };

  const handleValueChange = (newValue, property) => {
    handlePropertyChange("Value (per property)", newValue, property);
  };

  const handleQualityChange = (newQuality, property) => {
    handlePropertyChange("Quality (per value)", newQuality, property);
  };

  const handleNotesChange = (newNotes, property) => {
    handlePropertyChange("Notes (per property)", newNotes, property);
  };

  useEffect(() => {
    // Save the updated formatted data to local storage
    localStorage.setItem("UpdatedDataArray", JSON.stringify(selectedFileData));
  }, [selectedFileData]);

  const handleShowBin = () => {
    setClearClicked(!clearClicked);
  };

  const handleClearInput = (property) => {
    setSelectedFileData((data) => {
      const updatedData = data.map((item) => {
        if (item.Property === property) {
          // Clear all data for the selected property
          item["Value (per property)"] = "";
          item["Quality (per value)"] = "";
          item["Notes (per property)"] = "";
        }
        return item;
      });
  
      localStorage.setItem("UpdatedDataArray", JSON.stringify(updatedData));
      return updatedData;
    });
  };

  return (
    <div className="table-container">
      <table id="forms-table">
        <thead>
          <tr>
            <th>Property</th>
            <th>Values</th>
            <th>Quality</th>
            <th>Notes</th>
            <th>
              <button className="clear-column-header" onClick={handleShowBin}>
                Delete
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {formData.map((item, index) => (
            <FormRow
            key={`${activeTab}-${index}`}
              index={index}
              {...item}
              property={item.Property}
              values={item["Value (per property)"]}
              qualities={item["Quality (per value)"]}
              note={item["Notes (per property)"]}
              valueOptions={item["ValueOptions (per property)"]}
              qualityOptions={item["QualityOptions (per value)"]}
              compulsoryValue={item["CompulsoryValue (per property)"]}
              tooltip={item["Property Tooltip"]}
              onValueChange={(newValue) =>
                handleValueChange(newValue, item.Property)
              }
              onQualityChange={(newQuality) =>
                handleQualityChange(newQuality, item.Property)
              }
              onNotesChange={(newNotes) =>
                handleNotesChange(newNotes, item.Property)
              }
              clearClicked={clearClicked}
              handleClearInput={() => handleClearInput(item.Property)}
              isUnfilled={unfilledFields.includes(item.Property)}
              height={textareaHeights[index] || "38px"} // Default to '38px' if no height set
              onHeightChange={(newHeight) => updateTextareaHeight(index, newHeight)}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default FormTable;
